export default "__VITE_ASSET__79FWr8aL__"